"use client";

import { AlertCircle, ArrowRight, CheckCircle2, Zap } from "lucide-react";

import { useI18n } from "@llmgateway/i18n/react";

import { selectReliabilityText } from "./i18n";

export function ReliabilityFailover() {
	const { locale } = useI18n();
	const text = selectReliabilityText(locale).failover;

	return (
		<section className="py-20 sm:py-28">
			<div className="container mx-auto px-4 sm:px-6 lg:px-8">
				<div className="mx-auto max-w-5xl">
					<div className="mb-12 text-center sm:mb-16">
						<div className="mb-4 inline-flex items-center gap-2 rounded-full border border-border bg-muted px-4 py-1.5">
							<span className="text-xs font-mono text-blue-500">
								{text.eyebrow}
							</span>
						</div>
						<h2 className="mb-4 text-3xl font-bold tracking-tight text-balance sm:text-4xl lg:text-5xl">
							{text.title}
						</h2>
						<p className="mx-auto max-w-3xl text-lg leading-relaxed text-muted-foreground text-balance">
							{text.description}
						</p>
					</div>

					<div className="grid gap-6 md:grid-cols-3">
						<div className="rounded-xl border border-border bg-card p-6">
							<div className="mb-4 flex h-10 w-10 items-center justify-center rounded-lg bg-red-500/10 text-red-500">
								<AlertCircle className="h-5 w-5" />
							</div>
							<h3 className="mb-2 text-lg font-semibold">
								{text.cards[0]?.title}
							</h3>
							<p className="text-sm text-muted-foreground">
								{text.cards[0]?.description}
							</p>
						</div>
						<div className="rounded-xl border border-border bg-card p-6">
							<div className="mb-4 flex h-10 w-10 items-center justify-center rounded-lg bg-blue-500/10 text-blue-500">
								<Zap className="h-5 w-5" />
							</div>
							<h3 className="mb-2 text-lg font-semibold">
								{text.cards[1]?.title}
							</h3>
							<p className="text-sm text-muted-foreground">
								{text.cards[1]?.description}
							</p>
						</div>
						<div className="rounded-xl border border-border bg-card p-6">
							<div className="mb-4 flex h-10 w-10 items-center justify-center rounded-lg bg-emerald-500/10 text-emerald-500">
								<CheckCircle2 className="h-5 w-5" />
							</div>
							<h3 className="mb-2 text-lg font-semibold">
								{text.cards[2]?.title}
							</h3>
							<p className="text-sm text-muted-foreground">
								{text.cards[2]?.description}
							</p>
						</div>
					</div>

					<div className="mt-10 flex flex-col items-center justify-center gap-3 rounded-xl border border-dashed border-border bg-muted/30 p-6 sm:flex-row">
						<span className="text-sm font-medium text-muted-foreground">
							{text.flowStart}
						</span>
						<ArrowRight className="hidden h-4 w-4 text-muted-foreground sm:block" />
						<code className="rounded-md bg-background px-3 py-1 font-mono text-xs">
							POST /v1/chat/completions
						</code>
						<ArrowRight className="hidden h-4 w-4 text-muted-foreground sm:block" />
						<span className="text-sm font-medium text-foreground">
							{text.flowEnd}
						</span>
					</div>
				</div>
			</div>
		</section>
	);
}
